import _ from 'lodash';
import moment from 'moment';
import { momentProvider } from '@/services/clock.service';
import { StateService } from '@/services/state.service';
import { FilteringServiceConfig } from '@/services/filtering.service.config';
import { FrameworkService } from '@/services/framework.service';

/*
pageName: {
	days: { // just for the date picker
		min: 0, //
		max: 90,
		def: 30,
		addToQuery: false
	},
	setInitialFilters(searchFilters, queryFilters, filterTypes) {
		// returns nothing
	}
	setUpdatedFilters(searchFilters, updatedFilters, filterTypes) {
		...
		this.setDefaults(searchFilters, [], filterTypes);
		// returns nothing
	}
	setDefaults(searchFilters, queryFilters, filterTypes) {
		...
		// returns nothing
	}
}

*/

const filteringPagesConfig = {
	classSchedules: {
		days: {
			min: 0,
			max: 90,
			def: 30,
			addToQuery: false
		},
		setInitialFilters(searchFilters, queryFilters, filterTypes) {
			this.setDefaults(searchFilters, queryFilters, filterTypes);
			if (searchFilters.locations.length === 0) {
				const locationName = StateService.getLocationName();
				searchFilters.locations.push(locationName);
				searchFilters.chiclets.push({
					name: locationName,
					value: locationName,
					type: 'location',
					disabled: true // Home club is always disabled
				});
			}
		},
		setUpdatedFilters(searchFilters, updatedFilters, filterTypes) {
			searchFilters.tags = updatedFilters.tags;
			searchFilters.locations = updatedFilters.locations;
			searchFilters.organizers = updatedFilters.organizers;
			searchFilters.freeOnly = updatedFilters.freeOnly;
			searchFilters.chiclets = updatedFilters.chiclets;
			this.setDefaults(searchFilters, [], filterTypes);
		},
		setDefaults(searchFilters, queryFilters, filterTypes) {
			searchFilters.facets = [];
			for (let filterType of filterTypes) {
				const config = FilteringServiceConfig.getConfig(filterType);
				if (!config) continue;
				if (config.facet) searchFilters.facets.push(config.facet);
				if (queryFilters.length > 0) {
					const queryValues = _.filter(queryFilters, item => {
						return item.type === config.id;
					});
					_.forEach(queryValues, item => {
						config.result(searchFilters, [item.value]);
						searchFilters.chiclets.push({
							name: item.name,
							value: item.value,
							type: config.id,
							disabled: item.type === 'location' && item.value === StateService.getLocationName()
						});
					});
				}
			}
			searchFilters.tags.push(StateService.getClassSearchFormat());
		}
	},
	myReservations: {
		days: {
			min: -7,
			max: 270,
			def: 30,
			addToQuery: true
		},
		setInitialFilters(searchFilters, queryFilters, filterTypes) {
			this.setDefaults(searchFilters, queryFilters, filterTypes);
		},
		setUpdatedFilters(searchFilters, updatedFilters, filterTypes) {
			searchFilters.members = updatedFilters.members;
			searchFilters.startDate = moment(updatedFilters.startDate, 'l').format('l');
			searchFilters.endDate = moment(updatedFilters.endDate, 'l').format('l');
			searchFilters.chiclets = updatedFilters.chiclets;
			searchFilters.tags = updatedFilters.tags;
			this.setDefaults(searchFilters, [], filterTypes);
		},
		setDefaults(searchFilters, queryFilters, filterTypes) {
			searchFilters.facets = [];
			for (let filterType of filterTypes) {
				const config = FilteringServiceConfig.getConfig(filterType);
				if (config.facet) searchFilters.facets.push(config.facet);

				if (queryFilters.length > 0) {
					const queryValues = _.filter(queryFilters, item => {
						return item.type === config.id;
					});
					_.forEach(queryValues, item => {
						if (item.type === 'member') {
							_.forEach(FrameworkService.data('profile.members'), function(m) {
								if (parseInt(item.value.split(':')[1],10) === m.memberId) {
									item.name = m.firstName;
									item.value = 'member:' + m.firstName;
								}
							});
						}
						config.result(searchFilters, [item.value]);
						searchFilters.chiclets.push({
							name: item.name,
							value: item.value,
							type: config.id
						});
					});
				}
			}
		}
	},
	events: {
		days: {
			min: 0,
			max: 270,
			def: 90,
			addToQuery: true
		},
		setInitialFilters(searchFilters, queryFilters, filterTypes) {
			this.setDefaults(searchFilters, queryFilters, filterTypes);
			if (searchFilters.locations.length === 0) {
				const locationName = StateService.getLocationName();
				searchFilters.locations.push(locationName);
				searchFilters.chiclets.push({
					name: locationName,
					value: locationName,
					type: 'location',
					disabled: true // Home club is always disabled
				});
			}
		},
		setUpdatedFilters(searchFilters, updatedFilters, filterTypes) {
			searchFilters.startDate = moment(updatedFilters.startDate, 'l').format('l');
			searchFilters.endDate = moment(updatedFilters.endDate, 'l').format('l');
			searchFilters.tags = updatedFilters.tags;
			searchFilters.locations = updatedFilters.locations;
			searchFilters.freeOnly = updatedFilters.freeOnly;
			searchFilters.chiclets = updatedFilters.chiclets;
			this.setDefaults(searchFilters, [], filterTypes);
		},
		setDefaults(searchFilters, queryFilters, filterTypes) {
			searchFilters.facets = [];
			for (let filterType of filterTypes) {
				const config = FilteringServiceConfig.getConfig(filterType);
				if (!config) continue;
				if (config.facet) searchFilters.facets.push(config.facet);

				if (queryFilters.length > 0) {
					const queryValues = _.filter(queryFilters, item => {
						return item.type === config.id;
					});
					_.forEach(queryValues, item => {
						config.result(searchFilters, [item.value]);
						searchFilters.chiclets.push({
							name: item.name,
							value: item.value,
							type: config.id,
							disabled: item.type === 'location' && item.value === StateService.getLocationName()
						});
					});
				}
			}
			searchFilters.tags.push('format:Camp');
			searchFilters.tags.push('format:Event');
			searchFilters.tags.push('format:League');
			searchFilters.tags.push('format:Tournament');
		}
	},
	booking: {
		days: {
			min: 1,
			max: 14,
			def: 14,
			addToQuery: false
		},
		setInitialFilters(searchFilters, queryFilters, filterTypes) {
			this.setDefaults(searchFilters, queryFilters, filterTypes);
		},
		setUpdatedFilters(searchFilters, updatedFilters, filterTypes) {
			searchFilters.tags = updatedFilters.tags;
			searchFilters.locations = updatedFilters.locations;
			searchFilters.organizers = updatedFilters.organizers;
			searchFilters.date = updatedFilters.date;
			searchFilters.service = updatedFilters.service;
			searchFilters.chiclets = updatedFilters.chiclets;
			this.setDefaults(searchFilters, [], filterTypes);
		},
		setDefaults(searchFilters, queryFilters, filterTypes) {
			searchFilters.facets = [];
			for (let filterType of filterTypes) {
				const config = FilteringServiceConfig.getConfig(filterType);
				if (!config) continue;
				if (config.facet) searchFilters.facets.push(config.facet);
				if (queryFilters.length > 0) {
					const queryValues = _.filter(queryFilters, item => {
						return item.type === config.id;
					});
					_.forEach(queryValues, item => {
						config.result(searchFilters, [item.value]);
						searchFilters.chiclets.push({
							name: item.name,
							value: item.value,
							type: config.id
						});
					});
				}
			}
			searchFilters.upcs = StateService.authoredSettings.service; // Note: UPC (service) is deprecated. Use availability (context) instead.
			searchFilters.context = StateService.authoredSettings.context || 'pt';
		}
	},
	trainerList: {
		days: {
			min: 0,
			max: 0,
			def: 0,
			addToQuery: false
		},
		setInitialFilters(searchFilters, queryFilters, filterTypes) {
			this.setDefaults(searchFilters, queryFilters, filterTypes);
		},
		setUpdatedFilters(searchFilters, updatedFilters, filterTypes) {
			searchFilters.organizers = updatedFilters.organizers;
			searchFilters.service = updatedFilters.service;
			searchFilters.chiclets = updatedFilters.chiclets;
			this.setDefaults(searchFilters, [], filterTypes);
		},
		setDefaults(searchFilters, queryFilters, filterTypes) {
			searchFilters.facets = [];
			for (let filterType of filterTypes) {
				const config = FilteringServiceConfig.getConfig(filterType);
				if (!config) continue;
				if (config.facet) searchFilters.facets.push(config.facet);
				if (queryFilters.length > 0) {
					const queryValues = _.filter(queryFilters, item => {
						return item.type === config.id;
					});
					_.forEach(queryValues, item => {
						config.result(searchFilters, [item.value]);
						searchFilters.chiclets.push({
							name: item.name,
							value: item.value,
							type: config.id
						});
					});
				}
			}
		}
	}
};

export const FilteringServicePages = {
	classSchedules: 'classSchedules',
	myReservations: 'myReservations',
	events: 'events',
	booking: 'booking',
	trainerList: 'trainerList'
};

export const FilteringService = {
	build(id, data, idPrefix, queryFilters, savedSearchFilters, firstRun) {
		const config = FilteringServiceConfig.getConfig(id);
		if (config) {
			return config.control.build(config, data, idPrefix, savedSearchFilters, queryFilters, firstRun);
		} else {
			return null;
		}
	},

	search(id, valuesCollection, valuesToAdd, idPrefix) {
		const config = FilteringServiceConfig.getConfigByPrefix(id, idPrefix);
		config.result(valuesCollection, valuesToAdd);
	},

	getChicletName(id) {
		const config = FilteringServiceConfig.getConfig(id);
		return config.chiclet || config.name;
	},

	getDaysSettings(filterPage) {
		return filteringPagesConfig[filterPage].days;
	},

	searchDefault(filterPage, updateSource) {
		const daysSettings = filteringPagesConfig[filterPage].days;

		let newStartDate = updateSource && updateSource.type === 'startDate' ? updateSource.value : null;
		let newEndDate = updateSource && updateSource.type === 'endDate' ? updateSource.value : null;

		// Get the start date via the query string or set the default
		if (!newStartDate) {
			newStartDate = StateService.getQuery('startDate') || momentProvider().format('YYYY-MM-DD');
		}

		// Get the end date via the query string or set the default
		if (!newEndDate) {
			newEndDate = StateService.getQuery('endDate') || momentProvider().add(daysSettings.def, 'days').format('YYYY-MM-DD');
		}

		// Make sure the dates aren't reversed
		if (moment(newStartDate, 'YYYY-MM-DD').isAfter(moment(newEndDate, 'YYYY-MM-DD'))) {
			newEndDate = newStartDate;
		}

		const maxEndDate = momentProvider().add(daysSettings.max, 'days').format('YYYY-MM-DD');
		const minStartDate = momentProvider().add(daysSettings.min, 'days').format('YYYY-MM-DD');

		// Make sure the selected start date is within the proper range
		if (newStartDate && moment(newStartDate, 'YYYY-MM-DD').isAfter(moment(maxEndDate, 'YYYY-MM-DD'))) {
			newStartDate = maxEndDate;
		}
		if (newStartDate && moment(newStartDate, 'YYYY-MM-DD').isBefore(moment(minStartDate, 'YYYY-MM-DD'))) {
			newStartDate = minStartDate;
		}

		// Make sure the selected end date is within the proper range
		if (newEndDate && moment(newEndDate, 'YYYY-MM-DD').isAfter(moment(maxEndDate, 'YYYY-MM-DD'))) {
			newEndDate = maxEndDate;
		}
		if (newEndDate && moment(newEndDate, 'YYYY-MM-DD').isBefore(moment(minStartDate, 'YYYY-MM-DD'))) {
			newEndDate = minStartDate;
		}

		if (daysSettings.addToQuery) {
			StateService.setQueryStringKey('startDate', newStartDate);
			StateService.setQueryStringKey('endDate', newEndDate);
		}

		return {
			// Defaults for class schedules below.  Add more for other searches.
			// This object can have all of the properties of all searches
			tags: [],
			locations: [],
			organizers: [],
			facets: [],
			freeOnly: false,
			chiclets: [],
			members: [],
			reservationType: [],
			startDate: moment(newStartDate, 'YYYY-MM-DD').format('l'),
			endDate: moment(newEndDate, 'YYYY-MM-DD').format('l'),
			date: null,
			service: null
		};
	},

	getSelectedFiltersFromSaved(filterTypes, savedSearchFilters) {
		let _selectedFilters = [];
		for (let filterType of filterTypes) {
			const config = FilteringServiceConfig.getConfig(filterType);
			if (!config.saveGroup) continue;
			let savedFilters = savedSearchFilters[config.saveGroup];
			if (!savedFilters) continue;

			if (typeof savedFilters === 'boolean') savedFilters = [savedFilters];
			_selectedFilters = _.concat(
				_selectedFilters,
				config.control.findSavedFilters(savedFilters, config)
			);
		}
		return _selectedFilters;
	},

	getSelectedFiltersFromQuery(filterTypes) {
		let _selectedFilters = [];
		for (let filterType of filterTypes) {
			const config = FilteringServiceConfig.getConfig(filterType);
			if (config) {
				_selectedFilters = _.concat(
					_selectedFilters,
					config.control.findQueryFilters(config)
				);
			}
		}
		return _.cloneDeep(_selectedFilters);
	},

	getInitialFilters(filterPage, queryFilters, filterTypes) {
		const searchFilters = FilteringService.searchDefault(filterPage);
		filteringPagesConfig[filterPage].setInitialFilters(searchFilters, queryFilters, filterTypes);
		return searchFilters;
	},

	getUpdatedFilters(filterPage, updatedFilters, filterTypes) {
		const searchFilters =  FilteringService.searchDefault(filterPage);
		filteringPagesConfig[filterPage].setUpdatedFilters(searchFilters, updatedFilters, filterTypes);
		return searchFilters;
	}
};

